"use client";

import dynamic from "next/dynamic";
import { useAppContext } from "@/contexts/app";

const SignModal = dynamic(() => import("./modal"), { ssr: false });

export default function SignModalPortal() {
  const { showSignModal } = useAppContext();

  if (!showSignModal) {
    return null;
  }

  return <SignModal />;
}
